/** Attribute slot in the short token form. */
export interface AttributeSlot {
  name: string;
  /**
   * Position in short token form.
   * e.g.: if attribute `target` has position == 2, the token will be parsed as
   * [<type>, <content>, <href>, <target> <-- position 2 in the token].
   *
   * WARNING: do not change the position of existing tokens otherwise it could
   * lead to inconsistencies between releases.
   */
  position: number;
}

/**
 * A rule that represents which attributes are allowed on which tags.
 */
export interface AllowedTagsRule {
  tags: string[];
  attributes: AttributeSlot[];
}

/** Validation rules for content parser. */
export const ALLOWED_TAGS: AllowedTagsRule[] = [
  {
    tags: ['a'],
    attributes: [
      { name: 'href', position: 1 },
      { name: 'target', position: 2 },
      { name: 'class', position: 3 },
    ],
  },
  {
    tags: ['p', 'b', 'strong', 'br', 'i', 'em', 'sup', 'sub', 'span'],
    attributes: [{ name: 'class', position: 1 }],
  },
  {
    tags: ['cigna-icon', 'cigna-button'],
    attributes: [{ name: 'type', position: 1 }, { name: 'class', position: 2 }],
  },
  {
    tags: ['img'],
    attributes: [{ name: 'src', position: 1 }, { name: 'class', position: 2 }],
  },
];

/** How much depth is allowed. */
export const MAX_DEPTH = 2;
